import _ from "lodash";
import { ExportReq, HttpService, Records } from "@/core";
import { ExportResp } from "@/core/interface";
import {
  ProfilePageReq,
  ProfilePageResp,
  ProfileSimpleListReq,
  ProfileSimpleListResp,
  ProfileDetailResp,
  ProfileReq,
  TeamTypeEnum,
  Cooperation,
} from "./profile.interface";

import { QuantityRecord } from "./form/quantity-table/quantity-table.interface";

export class ProfileService {
  // 用来循环传入的工程量是否是空 或者 没有传递任何数据进来
  static validCategory(list: QuantityRecord[] = []) {
    if (list.length === 0) {
      return false;
    }
    let valid = true;
    for (let i = 0; i < list.length; i++) {
      const item = list[i];
      if (!item.uuid || !item.count) {
        valid = false;
        break;
      }
    }
    return valid;
  }
  static usePageApi() {
    const api = (params: ProfilePageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/subcontract/pageList",
        params,
      });
    return HttpService.usePagination<ProfilePageResp>(api);
  }
  static useExportApi() {
    const api = (ids: ExportReq) =>
      HttpService.axios({
        method: "POST",
        url: "/subcontract/export",
        data: { ids },
      });
    return HttpService.useRequest<ExportResp>(api);
  }
  static useSimpleListApi() {
    const api = (params: ProfileSimpleListReq, url = "/project/simple/list") =>
      HttpService.axios({
        method: "GET",
        url,
        params,
      });
    return HttpService.usePagination<ProfileSimpleListResp>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/subcontract/${id}`,
      });
    return HttpService.useRequest<ProfileDetailResp>(api);
  }

  static useCreateApi() {
    const api = (data: ProfileReq) =>
      HttpService.axios({
        method: "POST",
        url: "/subcontract/all",
        data: ProfileService.profileReqToAjaxData(data),
      });
    return HttpService.useRequest<{ id: string }>(api);
  }

  // 根据项目id查找往来公司
  static useFindCompanyApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "get",
        url: `/project/${id}/lastCompany`,
      });
    return HttpService.useRequest<Cooperation>(api);
  }

  static useEditApi() {
    const api = (id: string, data: ProfileReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/subcontract/${id}`,
        data: ProfileService.profileReqToAjaxData(data),
      });
    return HttpService.useRequest<{ id: string }>(api);
  }

  static useDeleteApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "DELETE",
        url: `/subcontract/${id}`,
      });
    return HttpService.useRequest<{ id: string }>(api);
  }

  // 根据项目 ID 查找合同金额
  static useAmountApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/project/${id}/amount`,
      });
    return HttpService.useRequest<{ projectAmount: number }>(api);
  }

  static profileReqToAjaxData(req: ProfileReq) {
    req = _.cloneDeep(req);
    const {
      ...rest
    } = req;


    return {
      ...rest,
    };
  }

  static detailRespToProfileReq(resp: ProfileDetailResp): ProfileReq {
    const { ...rest } = resp;
    console.log('resp: ', resp);
    const req = new ProfileReq();
    req.pick(rest);
    console.log('req: ', req);
    return req;
  }
}
